
import "../../bower_components/fancybox/dist/jquery.fancybox.min.js";
import lazysizes from 'lazysizes';

// jquery is on CDN

$(document).ready(function() {


	 // fancybox

	$('[data-fancybox="pix"]').fancybox({
  		loop : true,
  		infobar : true,
  		smallBtn : true,
  		toolbar : false,
			buttons : ['zoom','close']
		});


});

